import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHouse1Floor = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 67 43",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M5.71094 16.9404H61.9718V36.8535H56.1457V21.897H42.9283V36.8535H5.71094V16.9404Z",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 41.1304,
			height: 4.95652,
			transform: "matrix(1 0 0 -1 1.79785 41.8098)",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 11.5652,
			height: 11.7391,
			transform: "matrix(1 0 0 -1 42.8418 12.7664)",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.8413 6.41869H8.75437L1.79785 16.9404H65.7979L58.8413 6.41869H54.4065",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 9.65217,
			height: 4.95652,
			transform: "matrix(1 0 0 -1 56.1455 41.8098)",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.624 41.8098H56.4936",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 16.7826,
			height: 9.08696,
			transform: "matrix(1 0 0 -1 12.8086 31.0273)",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.2002 31.0273V21.9404",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0586 31.0273L32.3412 31.0273",
			stroke: "#808080",
			strokeWidth: 1.2
		})
	]
});
const ForwardRef = forwardRef(SvgHouse1Floor);
export default ForwardRef;
